/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ opponent: NonNullable<unknown>, when: NonNullable<unknown> }} Home_Next_GameInputs */

const th_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ถัดไป: ${i?.opponent} · ${i?.when}`)
};

const en_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next: ${i?.opponent} · ${i?.when}`)
};

const ja_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`次: ${i?.opponent} · ${i?.when}`)
};

const zh_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一场：${i?.opponent} · ${i?.when}`)
};

const es_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Siguiente: ${i?.opponent} · ${i?.when}`)
};

const pt_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo: ${i?.opponent} · ${i?.when}`)
};

const id_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berikutnya: ${i?.opponent} · ${i?.when}`)
};

const fr_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochain : ${i?.opponent} · ${i?.when}`)
};

const tl_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Susunod: ${i?.opponent} · ${i?.when}`)
};

const vi_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kế tiếp: ${i?.opponent} · ${i?.when}`)
};

const ko_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다음: ${i?.opponent} · ${i?.when}`)
};

const de_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Als Nächstes: ${i?.opponent} · ${i?.when}`)
};

const ru_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Далее: ${i?.opponent} · ${i?.when}`)
};

const tr_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sırada: ${i?.opponent} · ${i?.when}`)
};

const it_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossima: ${i?.opponent} · ${i?.when}`)
};

const pl_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Następny: ${i?.opponent} · ${i?.when}`)
};

const uk_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Далі: ${i?.opponent} · ${i?.when}`)
};

const hi_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अगला: ${i?.opponent} · ${i?.when}`)
};

const ar_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`التالي: ${i?.opponent} · ${i?.when}`)
};

const ms_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seterusnya: ${i?.opponent} · ${i?.when}`)
};

const bn_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`পরবর্তী: ${i?.opponent} · ${i?.when}`)
};

const zh_tw2_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一場：${i?.opponent} · ${i?.when}`)
};

const zh_hk2_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下一場：${i?.opponent} · ${i?.when}`)
};

const ur_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اگلا: ${i?.opponent} · ${i?.when}`)
};

const fa_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`بعدی: ${i?.opponent} · ${i?.when}`)
};

const sw_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inayofuata: ${i?.opponent} · ${i?.when}`)
};

const nl_home_next_game = /** @type {(inputs: Home_Next_GameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hierna: ${i?.opponent} · ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Next: {opponent} · {when}" |
*
* @param {Home_Next_GameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_next_game = /** @type {((inputs: Home_Next_GameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Next_GameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_next_game(inputs)
	if (locale === "ja") return ja_home_next_game(inputs)
	if (locale === "zh") return zh_home_next_game(inputs)
	if (locale === "es") return es_home_next_game(inputs)
	if (locale === "pt") return pt_home_next_game(inputs)
	if (locale === "id") return id_home_next_game(inputs)
	if (locale === "fr") return fr_home_next_game(inputs)
	if (locale === "tl") return tl_home_next_game(inputs)
	if (locale === "vi") return vi_home_next_game(inputs)
	if (locale === "ko") return ko_home_next_game(inputs)
	if (locale === "de") return de_home_next_game(inputs)
	if (locale === "ru") return ru_home_next_game(inputs)
	if (locale === "tr") return tr_home_next_game(inputs)
	if (locale === "it") return it_home_next_game(inputs)
	if (locale === "pl") return pl_home_next_game(inputs)
	if (locale === "uk") return uk_home_next_game(inputs)
	if (locale === "hi") return hi_home_next_game(inputs)
	if (locale === "ar") return ar_home_next_game(inputs)
	if (locale === "ms") return ms_home_next_game(inputs)
	if (locale === "bn") return bn_home_next_game(inputs)
	if (locale === "zh-TW") return zh_tw2_home_next_game(inputs)
	if (locale === "zh-HK") return zh_hk2_home_next_game(inputs)
	if (locale === "ur") return ur_home_next_game(inputs)
	if (locale === "fa") return fa_home_next_game(inputs)
	if (locale === "sw") return sw_home_next_game(inputs)
	if (locale === "nl") return nl_home_next_game(inputs)
	return en_home_next_game(inputs)
});